import { connect } from 'react-redux';
import { Header } from '@zocdoc/components/src/Layout';
import { UPDATE_PRIVACY_POLICY_BANNER_FLAG } from '@zocdoc/components/src/experiments';
import { withAB } from '../../config/ab';
import { trackConversion as trackSignInLinkClickConversion } from '../../config/ab/actions';
import {
    trackPageHeaderLogoClick as onLogoClick,
    trackPageHeaderCTALinkClick as onCTALinkClick,
    trackClickHeaderCustomLink as onCustomLinkClick,
    trackUsernameDropdownClick as onUsernameDropdownClick,
    trackUsernameDropdownLinks as onUsernameDropdownLinkClick,
    trackSeeAllNotifications as onSeeAllNotificationsClick,
    trackNotificationsCounterClick as onNotificationDropdownClick,
    trackNotificationClick as onNotificationClick,
    trackUpcomingAppointmentClick as onUpcomingAppointmentClick,
    trackMobileLinkClick as onMobileMenuLinkClick,
    trackUniversalSearchHeaderSubmit as onUniversalSearchHeaderSubmit,
    trackClickSignInDropdown as onSignInDropdownClick,
    trackClickSignInDropdownLink as onSignInDropdownLinkClick,
} from './eventTrackingActions';

const mapDispatchToProps = {
    onLogoClick,
    onCustomLinkClick,
    onCTALinkClick,
    onUsernameDropdownClick,
    onUsernameDropdownLinkClick,
    onSeeAllNotificationsClick,
    onNotificationDropdownClick,
    onNotificationClick,
    onUpcomingAppointmentClick,
    onMobileMenuLinkClick,
    onUniversalSearchHeaderSubmit,
    onSignInDropdownClick,
    onSignInDropdownLinkClick,
    trackSignInLinkClickConversion,
};

const headerWithAb = withAB(UPDATE_PRIVACY_POLICY_BANNER_FLAG)(Header);

export default connect(null, mapDispatchToProps)(headerWithAb);
